/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MenuInputs */

const th_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมนู`)
};

const en_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const ja_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニュー`)
};

const zh_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`菜单`)
};

const es_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú`)
};

const pt_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const id_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const fr_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const tl_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const vi_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const ko_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메뉴`)
};

const de_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü`)
};

const ru_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню`)
};

const tr_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü`)
};

const it_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const pl_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const uk_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню`)
};

const hi_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेन्यू`)
};

const ar_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القائمة`)
};

const ms_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const bn_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মেনু`)
};

const zh_tw2_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選單`)
};

const zh_hk2_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選單`)
};

const ur_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مینو`)
};

const fa_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فهرست`)
};

const sw_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyu`)
};

const nl_menu = /** @type {(inputs: MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {MenuInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const menu = /** @type {((inputs?: MenuInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MenuInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_menu(inputs)
	if (locale === "ja") return ja_menu(inputs)
	if (locale === "zh") return zh_menu(inputs)
	if (locale === "es") return es_menu(inputs)
	if (locale === "pt") return pt_menu(inputs)
	if (locale === "id") return id_menu(inputs)
	if (locale === "fr") return fr_menu(inputs)
	if (locale === "tl") return tl_menu(inputs)
	if (locale === "vi") return vi_menu(inputs)
	if (locale === "ko") return ko_menu(inputs)
	if (locale === "de") return de_menu(inputs)
	if (locale === "ru") return ru_menu(inputs)
	if (locale === "tr") return tr_menu(inputs)
	if (locale === "it") return it_menu(inputs)
	if (locale === "pl") return pl_menu(inputs)
	if (locale === "uk") return uk_menu(inputs)
	if (locale === "hi") return hi_menu(inputs)
	if (locale === "ar") return ar_menu(inputs)
	if (locale === "ms") return ms_menu(inputs)
	if (locale === "bn") return bn_menu(inputs)
	if (locale === "zh-TW") return zh_tw2_menu(inputs)
	if (locale === "zh-HK") return zh_hk2_menu(inputs)
	if (locale === "ur") return ur_menu(inputs)
	if (locale === "fa") return fa_menu(inputs)
	if (locale === "sw") return sw_menu(inputs)
	if (locale === "nl") return nl_menu(inputs)
	return en_menu(inputs)
});